//hooks
import React, { useState } from 'react';
import { NotificationConsumer } from '../hooks/context/NotificationContext';
import { UserConsumer } from '../hooks/context/UserContext';

//type
import { otpReqType } from '../api/otp/type/OtpType';

//api
import { PostOtp } from '../api/otp/PostOtp';

//mui
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../translate/i18n';

//otp library
import OtpInput from 'react-otp-input';

//image
import login_logo from "../assets/login/login_logo.png"

interface otpProps {
    openOtp: boolean
    setOpenOtp:(open:boolean) =>void
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
    children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const Otp = ({openOtp, setOpenOtp} :otpProps) => {

    const { t } = useTranslation();
    const [otp, setOtp] = useState<string>('');
    const [loading, setLoading] = useState<Boolean>(false)
    let {setNoteMessage, setShowMessage, setStatusCode} = NotificationConsumer()
    let {userData, setUserData} = UserConsumer()
    const handleClose = () => {
        setOpenOtp(false);
    };

    const handleOtp = async(payload:otpReqType)=> {
        try {
        setLoading(true)
        const result = await PostOtp(payload);
        console.log('otp successful:');
        if(result.code == 200) {
            setNoteMessage(result.message)
            setShowMessage(true)
            setStatusCode(result.code)
            setUserData(result.data)
        }
        else {
            setNoteMessage(result.message)
            setShowMessage(true)
            setStatusCode(result.code)
        }
        handleClose();
        }
        catch (error:any) {
            console.error('otp failed', error);
            setNoteMessage(error.response.data.message)
            setShowMessage(true)
            setStatusCode(error.status)
        }
        finally {
        setLoading(false)
        }
    }

    return (
        <div>
            <Dialog 
            open={openOtp}
            onClose={handleClose}
            slots={{
            transition: Transition,
            }}
            disableRestoreFocus
            >
                <DialogTitle className='flex gap-3'>
                    <img className='w-[30px] h-[30px]' src={login_logo} alt='no=photo'/>
                    <p>{t("gettak")}</p>
                </DialogTitle>
                <DialogTitle className='flex justify-center !text-[30px]'>
                    <p>{t("enter_verification_code")}</p>
                </DialogTitle>
                <p className='text-[12px] text-center text-[#7F7F7F]'>{`${t("we_have_send_a_code_to")} ${userData?.phone}`}</p>
                <DialogContent>
                    <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={5}
                    renderSeparator={<span>-</span>}
                    renderInput={(props) => <input {...props}
                    style={{
                        width: "3rem",
                        height: "3rem",
                        margin: "0 0.5rem",
                        fontSize: "1.5rem",
                        borderRadius: "0.5rem",
                        border: "2px solid #ccc",
                        textAlign: "center",
                        outline: "none",
                        transition: "border-color 0.2s ease",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#4F46E5")}
                    onBlur={(e) => (e.target.style.borderColor = "#ccc")}
                    />}
                    />
                </DialogContent>
                <DialogActions className={`!pb-5 ${i18n.language === "en" ? "!justify-start" : "!justify-start"}`}>
                    <Button className='w-full h-[62px] !bg-customerColor !text-white !rounded-full' onClick={() => handleOtp({ otp: otp, phone: String(userData?.phone) })}>
                    {loading 
                    ? <CircularProgress className='w-1 h-1'/>
                    :t("confirm")
                    }
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default Otp